import { defaultHttpClient } from '../../httpClient';
import type { MarketBannerListResponse } from './types';

export const getMarketBanner = (marketId: number) => {
  return defaultHttpClient
    .request<MarketBannerListResponse>({
      method: 'GET',
      url: `/api/v2/markets/${marketId}/banners/`,
    })
    .then(result => {
      return result.data;
    });
};
